import React from "react";
import { Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import BackgroundImage from "@components/BackgroundImageCst";
import CardHomeCst from "@components/CardHomeCst";
import { useEffect } from "react";
import { useAuth } from "@context/auth";
import { useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import Breadcrumb from "@components/Breadcrumb";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useMenu, useNavigaionRoutes } from "@hooks/useNavigation";
import { useResetFilters } from "@hooks/useFiltersProvider";

const ThirdParts: React.FC = () => {
  const { t } = useTranslation(["third-parts-page", "common"]);
  const { user } = useAuth();
  const navigate = useNavigate();
  const menuItem = useMenu();
  const navigation = useNavigaionRoutes();

  useResetFilters();

  useEffect(() => {
    if (user && user.organization_id !== 1) {
      navigate(`/corporate/${user.organization_id}/detail`);
    }
  }, [user]);

  const thirdPartsSection = [
    "third-parts.freshdesk",
    "third-parts.accredible",
    "third-parts.lti_account",
  ];

  let thirdPartsMenu = [];
  if (menuItem.length > 0) {
    thirdPartsMenu = navigation
      .find((el) => el.to === "third-parts")
      ?.children?.filter((el: { section: string }) => {
        return thirdPartsSection?.includes(el.section);
      });
  }

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"300px"}
        image="section-third-parts.jpg"
        position={"absolute"}
        zIndex={-1}
        fullpage={true}
      />
      <Breadcrumb />
      <Container maxWidth="xxl">
        <HeroCst title={t("hero-title")} description={t("hero-description")} />
        <Grid container spacing={3}>
          {thirdPartsMenu.map((card: any, index: number) => (
            <Grid key={index} item xs={12} md={6} xl={4}>
              <CardHomeCst
                image={card.image}
                title={card.text}
                description={card.description}
                secondaryBtnLabel={card.buttonLabel}
                to={card.link || card.to}
                disabled={card.disabled}
                externalLink={card.external}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </AnimationFadeIn>
  );
};

export default ThirdParts;
